import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import { Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import SelectComponent from '../../components/SelectComponent';
import { useLoading } from '../../components/LoadingContext'; 
import { ToastContainer, toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Card, Row, Col } from 'react-bootstrap'; 
import { Modal } from 'react-bootstrap';




const Config2fa = () => {
 
   const [formData, setFormData] = useState({
     username: '',
     email: '',
     nombre: '',
     apellido: '',
     cargo_id: '',
     role_id: '',
     password: '',
     password_confirmation: '', // Añadir confirmación de contraseña
   });


  const navigate = useNavigate();
  const { id } = useParams();
  const { setLoading } = useLoading();
  const [showPassword, setShowPassword] = useState(false); // Control de visibilidad de la contraseña
  const [passwordError, setPasswordError] = useState(''); // Control de errores de contraseña
  const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado
   const [qrImage, setQrImage] = useState(''); 
   const [f2aEnabled, setF2aEnabled] = useState(''); 
   const [showModalGenerar, setShowModalGenerar] = useState(false); 
   const [showModalDesactivar, setShowModalDesactivar] = useState(false); 
   const [confirmPassword, setConfirmPassword] = useState('');
const [error, setError] = useState('');


useEffect(() => {
  fetchUserData();
}, [userId]);


  const fetchUserData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response.data.user;
      setQrImage(response.data.qr_image);
      setF2aEnabled(userData.f2a_enabled);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };
  


  const handleRegenerarCodigo = async () => {
    try {
      await axios.post('2fa/regenerate', {
        password: confirmPassword,
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
  
      setShowModalGenerar(false);
      setConfirmPassword('');
      // puedes recargar el QR si es necesario aquí
      fetchUserData();
  
    } catch (err) {
      setError('Contraseña incorrecta o error al generar el código');
    }
  };

  const handleDesactivar2FA = async () => {
    try {
      await axios.post('/2fa/disable', {
        password: confirmPassword,
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
  
      setShowModalDesactivar(false);
      setConfirmPassword('');
      setError('');
      fetchUserData(); // refresca el estado y oculta el QR
  
    } catch (err) {
      setError('Contraseña incorrecta o error al desactivar 2FA');
    }
  };
  const toImgSrc = (val) => {
  if (!val) return '';
  // Ya es data URI PNG o SVG -> usar tal cual
  if (val.startsWith('data:image/')) return val;
  // Viene un SVG en texto ("<svg ..." o "<?xml ...")
  if (val.startsWith('<svg') || val.startsWith('<?xml')) {
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(val);
  }
  // Por si te llega SVG pero ya URL-encoded sin prefijo
  if (val.startsWith('%3Csvg') || val.startsWith('%3C?xml')) {
    return 'data:image/svg+xml;utf8,' + val; // ya está encoded
  }
  return val; // fallback
};
  
  
 

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value || '',
    }));
  };
  return (
    <div className="container mt-5">
      <div className="card-box">
        <h3 className="mb-4 text-center">Verificación en 2 pasos</h3>
  
        {f2aEnabled ? (
          <div className="row justify-content-center align-items-center">
            {/* QR Code - izquierda */}
            <div className="col-md-4 text-center mb-3">
            {qrImage && (
                <img src={toImgSrc(qrImage)} alt="QR 2FA" width={200} height={200} />
              )}

              <p className="mt-2 fw-bold">Código QR actual del usuario</p>
              <p className="text-muted" style={{ fontSize: '0.85rem' }}>
                Escanea este código en tu app de Google Authenticator o una aplicación compatible para recibir tus códigos de verificación.
              </p>
            </div>
  
            {/* Botones - derecha */}
            <div className="col-md-4 text-center mb-3">
              <div className="d-grid gap-2">
                <Button variant="primary" size="sm" onClick={() => setShowModalGenerar(true)}>
                  Generar nuevo código
                </Button>
                <Button variant="danger" size="sm" onClick={() => setShowModalDesactivar(true)}>
                  Desactivar 2FA
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center">
            <p className="text-danger fw-bold">
              Tu cuenta no tiene la verificación en dos pasos activada. Esto representa un riesgo de seguridad.
            </p>
            <Button variant="success" size="sm" onClick={() => setShowModalGenerar(true)}>
              Activar 2FA
            </Button>
          </div>
        )}

        <Modal show={showModalGenerar} onHide={() => setShowModalGenerar(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Regenerar código 2FA</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="mb-3">
              Esto generará un nuevo código QR para tu inicio de sesión en 2 pasos y desactivará el código actual.
              Si deseas continuar, por favor ingresa tu contraseña para confirmar esta acción.
            </p>

            <Form.Group controlId="formPassword">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Introduce tu contraseña"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>

            {error && <p className="text-danger mt-2">{error}</p>}
          </Modal.Body>

          <Modal.Footer>
          <div className="d-flex justify-content-center gap-2">
            <Button variant="secondary" onClick={() => setShowModalGenerar(false)}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleRegenerarCodigo}>
              Confirmar y generar nuevo QR
            </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={showModalDesactivar} onHide={() => setShowModalDesactivar(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Desactivar verificación 2FA</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p className="mb-3 text-danger fw-bold">
      ¿Estás seguro de que deseas desactivar la verificación en dos pasos?
    </p>
    <p className="text-muted" style={{ fontSize: '0.85rem' }}>
      Esta acción hará que tu cuenta sea más vulnerable a accesos no autorizados. Ingresa tu contraseña para confirmar.
    </p>

    <Form.Group controlId="formDisablePassword">
      <Form.Label>Contraseña</Form.Label>
      <Form.Control
        type="password"
        placeholder="Introduce tu contraseña"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
    </Form.Group>

    {error && <p className="text-danger mt-2">{error}</p>}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModalDesactivar(false)}>
      Cancelar
    </Button>
    <Button variant="danger" onClick={handleDesactivar2FA}>
      Desactivar 2FA
    </Button>
  </Modal.Footer>
</Modal>


      </div>
    </div>

    
  );
  
  
  
  
  
  
};

export default Config2fa;
